import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  searchByPageBySyncCard,
} from "app/services/TreatmentPlanCardService";
import { syncCard } from "app/services/SyncCRMService";
export default class RegisterCardStore {
  searchRegisterCard = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
  };
  selectCardAsync = [];
  resetSelectedRows = false;

  pageRegisterCard = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterCard = async () => {
    let { orderDate, ...ortherData } = this.searchRegisterCard;
    return await searchByPageBySyncCard({
      ...ortherData,
      getStaffRevenues: true,
    })
      .then(({ data }) => {
        this.pageRegisterCard = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  handleChangeFormSearchService = (searchRegisterCard) => {
    this.searchRegisterCard = {
      ...this.searchRegisterCard,
      ...searchRegisterCard,
    };
    this.pagingRegisterCard();
  };

  setSelectCardAsync = (list) => {
    this.selectCardAsync = list;
  };

  syncListCardToCrm = async () => {
    const patientIds = this.selectCardAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;

    return await syncCard(patientIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        if (data) {
          toast.success("Đồng bộ thẻ thành công");
          this.pagingRegisterCard();
        } else {
          toast.error("Đồng bộ thẻ có lỗi");
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        console.error(error);
        toast.error("Đồng bộ thẻ có lỗi");
      });
  };

  resetStore = () => {
    this.searchRegisterCard = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
    this.pageRegisterCard = new PageResponse();
  };
}
